import React, { useState, useEffect, Fragment, useContext } from "react";

import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControl,
  Autocomplete,
  LinearProgress,
  FormLabel,
  Fade,
} from "@mui/material";
import { Button } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { NavLink, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material/";

import {
  CommonSubHeader,
  isValidEmail,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";
import { UserContext } from "../../Components/Context/Context";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

const Crear = () => {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);

  const { goPanel, goTable, buildTableUrl } = useLocationHelpers();
  const Swal = require("sweetalert2");
  const [flagCompanySelected, setFlagCompanySelected] = useState(true);
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);

  // Estados para abrir las opciones y sus datos
  const [openOptions, setOpenOptions] = useState({
    userRole: false,
    company: false,
    // offices: false,
    provinces: false,
    asociations: false,
    zones: false,
    status: false,
  });

  const [options, setOptions] = useState({
    userRole: [],
    company: [],
    // offices: [],
    provinces: [],
    asociations: [],
    zones: [],
    status: [],
    userTasks: [],
    documentTypes: [],
  });

  // Loading Options
  const loadingOptions = Object.fromEntries(
    Object.entries(openOptions).map(([key, value]) => [
      key,
      value && (!options[key] || options[key].length === 0),
    ]),
  );

  // Toma de valores
  const [formValues, setFormValues] = useState({
    userRole: "",
    companyId: "",
    userEmail: "",
    userName: "",
    userSurname: "",
    userAddress: "",
    userPostalCode: "",
    userDocument: "",
    userType: "",
    userPhone: "",
    provinceName: "",
    asociationId: "",
    zonesId: "",
    userTasks: "",
    valCaseTypeForm: "",
    status: 1,
    documentType: {
      name: "Seleccionar",
      id: 0,
    },
  });

  const [flag, setFlag] = useState(false);

  const [statuses, setStatuses] = useState([
    {
      nombre: "Seleccionar",
      id: -1,
    },
    {
      nombre: "Inactivo",
      id: 0,
    },
    {
      nombre: "Activo",
      id: 1,
    },
  ]);

  // GET DATA LIST
  const getDataList = async (actualUrl) => {
    setFlag(true);
    const url = `${actualUrl}/createlawyer`;

    try {
      const response = await api.post(url);

      const { provinces, companies, zones, roles, document_types } =
        response.data;

      console.log(roles);

      roles
        .map((data) => ({
          name: data?.type,
          id: data?.id,
        }))
        .filter((data) => userData?.type >= data?.id);

      const defaultOptions = { id: 0 };
      setOptions({
        userRole: [{ type: "Seleccionar", ...defaultOptions }, ...roles],
        company: [
          { company_name: "Seleccionar", ...defaultOptions },
          ...companies,
        ],
        userTasks: [
          { nombre: "Ninguno", id: 0 },
          { nombre: "Abogado", id: 1 },
          { nombre: "Perito", id: 2 },
        ],
        provinces: [
          { provincia: "Seleccionar", ...defaultOptions },
          ...provinces,
        ],
        zones: [{ zona: "Seleccionar", ...defaultOptions }, ...zones],
        documentTypes: [
          { name: "Seleccionar", ...defaultOptions },
          ...document_types,
        ],
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o í©xito
    }
  };

  // Form submit handler
  const handleClientsFormInformation = async () => {
    console.log(formValues);

    if (formValues?.userEmail && !isValidEmail(formValues?.userEmail)) {
      Swal.fire({
        icon: "error",
        title: "Email inválido",
        text: "Por favor ingrese un correo electrónico válido",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    if (!validateFields()) {
      showValidationErrors();
      return;
    }

    const formData = new FormData();
    formData.append("type", formValues?.userRole);
    formData.append("company_id", formValues?.companyId);
    formData.append("lawyer", null);
    formData.append("email", formValues?.userEmail);
    formData.append("name", formValues?.userName);
    formData.append("surname", formValues?.userSurname);
    formData.append("address", formValues?.userAddress);
    formData.append("postalcode", formValues?.userPostalCode);
    formData.append("document_type", formValues?.documentType?.id ?? 0);
    formData.append("nif", formValues?.userDocument);
    formData.append("phone", formValues?.userPhone);
    formData.append("province", formValues?.provinceName);
    formData.append("contact_id", null);
    formData.append("asociation", formValues?.asociationId);
    formData.append("zone", formValues?.zonesId);
    formData.append("status", formValues?.status);
    formData.append("is_lawyer", formValues?.userTasks);
    formData.append("notas", formValues?.valCaseTypeForm);
    formData.append("marketing", 0);

    const queryUrl = `${process.env.REACT_APP_API_URL}/storelawyer`;

    const result = await Swal.fire({
      title: "¿Desea guardar los cambios?",
      icon: "question",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Guardar",
      denyButtonText: "Volver",
    });

    if (!result.isConfirmed) {
      if (result.isDenied) {
        Swal.fire("¡Los cambios no han sido guardados!", "", "info");
      }
      return;
    }

    Swal.fire({
      title: "Guardando...",
      text: "Por favor espera",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await api.post(queryUrl, formData);

      if (!response.data.success) {
        Swal.close();

        const { message, error, field } = response.data;

        if (error === "duplicate_email" || field === "email") {
          Swal.fire({
            title: "¡Correo existente!",
            icon: "error",
            text: message,
            confirmButtonColor: "#1ab394",
          });
        } else {
          Swal.fire({
            title: "Error",
            icon: "error",
            text: message || "Error desconocido",
            confirmButtonColor: "#1ab394",
          });
        }

        return;
      }

      const usuario = response?.data?.user_created?.id;

      // Paso 1: í©xito
      Swal.update({
        icon: "success",
        title: "Usuario guardado",
        text: "Preparando reDirección...",
        showConfirmButton: false,
      });

      // Espera visual real
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Paso 2: transición
      Swal.update({
        title: "Redireccionando...",
        text: "",
      });

      await new Promise((resolve) => setTimeout(resolve, 800));

      Swal.close();

      navigate(`/usuarios/ver?id=${usuario}`);
    } catch (error) {
      Swal.close();

      const message = error.response?.data?.message || "Error del servidor";

      Swal.fire({
        title: "Error",
        icon: "error",
        text: "Por favor contacte al soporte",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  // Validate required fields
  const validateFields = () => {
    const fields = [
      { value: formValues?.userRole, name: "Tipo de usuario" },
      { value: formValues?.companyId, name: "Empresa" },
      { value: formValues?.userName, name: "Nombre" },
      {
        value: formValues?.documentType?.id ?? 0,
        name: "Tipo de documento",
      },
      { value: formValues?.userDocument, name: "Documento" },
      { value: formValues?.userAddress, name: "Dirección" },
      { value: formValues?.provinceName, name: "Provincia" },
      { value: formValues?.userPostalCode, name: "Código postal" },
      { value: formValues?.userEmail, name: "Email" },
      { value: formValues?.userPhone, name: "Teléfono" },

      // El valor 0 es válido porque representa "Inactivo".
      { value: formValues?.status, name: "Estado", allowZero: true },
    ];

    return fields.every((field) => {
      const value = field.value;

      if (field.allowZero) {
        return (
          value !== "" && value !== null && value !== undefined && value !== -1
        );
      }

      return (
        value !== "" && value !== null && value !== undefined && value !== 0
      );
    });
  };

  const showValidationErrors = () => {
    const requiredFields = [
      { value: formValues?.userRole, name: "Tipo de usuario" },
      { value: formValues?.companyId, name: "Empresa" },
      { value: formValues?.userName, name: "Nombre" },
      {
        value: formValues?.documentType?.id ?? 0,
        name: "Tipo de documento",
      },
      { value: formValues?.userDocument, name: "Documento" },
      { value: formValues?.userAddress, name: "Dirección" },
      { value: formValues?.provinceName, name: "Provincia" },
      { value: formValues?.userPostalCode, name: "Código postal" },
      { value: formValues?.userEmail, name: "Email" },
      { value: formValues?.userPhone, name: "Teléfono" },
      { value: formValues?.status, name: "Estado", allowZero: true },
    ];

    const missingFields = requiredFields
      .filter((field) => {
        const value = field.value;

        if (field.allowZero) {
          return (
            value === "" ||
            value === null ||
            value === undefined ||
            value === -1
          );
        }

        return (
          value === "" || value === null || value === undefined || value === 0
        );
      })
      .map((field) => `<li>${field.name}</li>`)
      .join("");

    Swal.fire({
      title: "¡Campos incompletos!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor complete los siguientes campos:<ul>${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
    });
  };

  // SET VARIABLES
  useEffect(() => {
    getDataList(process.env.REACT_APP_API_URL);
  }, []);

  useEffect(() => {
    const loadOptions = (key) => {
      if (loadingOptions[key]) {
        setTimeout(() => {
          // obtener los datos de options de alguna fuente externa si es necesario
          setOptions((prevOptions) => ({
            ...prevOptions,
            [key]: options[key], // Asumiendo  los datos cargados en options[key]
          }));
        }, 1000); // Tiempo de espera para simular carga
      }
    };

    Object.keys(openOptions).forEach(loadOptions);
  }, [loadingOptions, openOptions]);

  const fieldsConfig = [
    {
      type: "autocomplete",
      id: "userRole",
      label: "Tipo de usuario",
      onChange: (value) => {
        setFormValues((prev) => ({
          ...prev,
          userRole: value ? value.id : null,
        }));
      },
      open: openOptions.userRole,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, userRole: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, userRole: false })),
      options: options.userRole,
      loading: loadingOptions.userRole,
      getOptionLabel: (option) => option.type,
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "autocomplete",
      id: "companyId",
      label: "Empresa",
      onChange: (value) => {
        setFormValues((prev) => ({
          ...prev,
          companyId: value ? value.id : null,
        }));
        filterDataByCompany(value ? value.id : 0);
      },
      open: openOptions.company,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, company: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, company: false })),
      options: options.company || [], // Asigna un arreglo vací­o si options.company es undefined
      loading: loadingOptions.company,
      getOptionLabel: (option) => option.company_name,
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "autocomplete",
      id: "userTasks",
      label: "Tareas de",
      onChange: (value) =>
        setFormValues((prev) => ({ ...prev, userTasks: value.id })),
      open: openOptions.userTasks,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, userTasks: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, userTasks: false })),
      options: options.userTasks,
      loading: loadingOptions.userTasks,
      getOptionLabel: (option) => option.nombre,
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "text",
      id: "userEmail",
      label: "Email",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userEmail: e.target.value })),
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "text",
      id: "userName",
      label: "Nombre",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userName: e.target.value })),
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "text",
      id: "userSurname",
      label: "Apellido",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userSurname: e.target.value })),
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "autocomplete",
      id: "provinceName",
      label: "Provincia",
      onChange: (value) =>
        setFormValues((prev) => ({
          ...prev,
          provinceName: value ? value.provincia : null,
        })),
      open: openOptions.provinces,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, provinces: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, provinces: false })),
      options: options.provinces,
      loading: loadingOptions.provinces,
      getOptionLabel: (option) => option.provincia,
      show: true,
      grid: { xs: 6, md: 2, lg: 1 },
    },
    {
      type: "text",
      id: "userAddress",
      label: "Dirección",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userAddress: e.target.value })),
      show: true,
      grid: { xs: 6, md: 2, lg: 3 },
    },
    {
      type: "text",
      id: "userPostalCode",
      label: "Código Postal",
      onChange: (e) =>
        setFormValues((prev) => ({
          ...prev,
          userPostalCode: e.target.value,
        })),
      show: true,
      grid: { xs: 6, md: 2, lg: 2 },
    },
    {
      id: "document_type",
      key: "documentType",
      type: "autocomplete",
      label: "Tipo de documento",
      grid: { xs: 6, md: 3, lg: 3 },
      open: openOptions.documentTypes,
      options: options?.documentTypes || [],
      onChange: (event, value) => {
        const selected = event || { id: 0, name: "Seleccionar" };
        setFormValues((prev) => ({
          ...prev,
          documentType: selected || null,
        }));
      },
      isOptionEqualToValue: (option, value) => option.id === value?.id,
      getOptionLabel: (option) => option.name || "Seleccionar",
      show: true,
      onOpen: () =>
        setOpenOptions((prev) => ({ ...prev, documentTypes: true })),
      onClose: () =>
        setOpenOptions((prev) => ({ ...prev, documentTypes: false })),
    },
    {
      type: "text",
      id: "userDocument",
      grid: { xs: 6, md: 3, lg: 3 },
      label: "Documento",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userDocument: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userPhone",
      label: "Teléfono",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userPhone: e.target.value })),
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "autocomplete",
      id: "status",
      label: "Estado",
      defaultValue: statuses.find((status) => status.id === 1),
      onChange: (value) => {
        console.log(value);
        setFormValues((prev) => ({
          ...prev,
          status: value ? value.id : null,
        }));
      },
      open: openOptions.status,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, status: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, status: false })),
      options: statuses || [],
      loading: loadingOptions.status,
      getOptionLabel: (option) => option?.nombre || "Seleccionar",
      show: true,
      grid: { xs: 6 },
    },
    {
      type: "textarea",
      id: "valCaseTypeForm",
      label: "Notas",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, valCaseTypeForm: e.target.value })),
      show: true,
      grid: { xs: 6 },
    },
    // {
    //   type: "autocomplete",
    //   id: "officesId",
    //   label: "Despachos",
    //   onChange: (value) =>
    //     setFormValues((prev) => ({
    //       ...prev,
    //       officesId: value ? value.id : null,
    //     })),
    //   open: openOptions.offices,
    //   onOpen: () => setOpenOptions((prev) => ({ ...prev, offices: true })),
    //   onClose: () => setOpenOptions((prev) => ({ ...prev, offices: false })),
    //   options: options.offices,
    //   loading: loadingOptions.offices,
    //   getOptionLabel: (option) => option.office_name,
    //   show: true,
    //   disabled: flagCompanySelected,
    // },

    // {
    //   type: "autocomplete",
    //   id: "asociationId",
    //   label: "Asociación",
    //   onChange: (value) =>
    //     setFormValues((prev) => ({
    //       ...prev,
    //       asociationId: value ? value.id : null,
    //     })),
    //   open: openOptions.asociations,
    //   onOpen: () => setOpenOptions((prev) => ({ ...prev, asociations: true })),
    //   onClose: () =>
    //     setOpenOptions((prev) => ({ ...prev, asociations: false })),
    //   options: options.asociations,
    //   loading: loadingOptions.asociations,
    //   getOptionLabel: (option) => option.asoc_name,
    //   show: true,
    //   disabled: flagCompanySelected,
    // },
  ];

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = async (company_id) => {
    const resetDependentData = () => {
      setOptions((prevOptions) => ({
        ...prevOptions,
        asociations: [{ asoc_name: "Seleccionar", id: 0 }],
      }));
    };

    if (!company_id) {
      resetDependentData();
      setFlagCompanySelected(true);
      return;
    }

    try {
      setIsCompanyLoading(true);

      Swal.fire({
        title: "Actualizando empresa...",
        text: "Cargando asociaciones y datos dependientes.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      const queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;
      const response = await api.post(queryUrl, { company: company_id });

      if (!response?.data) {
        throw new Error("No se recibieron datos dependientes de la empresa.");
      }

      const { associations = [] } = response.data;

      setOptions((prevOptions) => ({
        ...prevOptions,
        asociations: [{ asoc_name: "Seleccionar", id: 0 }, ...associations],
      }));

      setFlagCompanySelected(false);
    } catch (error) {
      console.log(error);
      resetDependentData();

      await Swal.fire({
        title: "Error",
        text: "No se pudieron cargar los datos dependientes de la empresa seleccionada.",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
    } finally {
      setIsCompanyLoading(false);
      Swal.close();
    }
  };

  //////////////////// FILTER BY COMPANY  ///////////////////////
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Usuarios" subTitle="Crear" />
      <Fade in={!flag}>
        <Box
          component="form"
          sx={{ margin: "auto", "& > :not(style)": {} }}
          noValidate
          autoComplete="off"
          className="formMainContainer"
        >
          <Grid
            container
            style={{ textAlign: "center" }}
            className="fontSize"
            p={2}
          >
            {fieldsConfig.map(
              (field) =>
                field.show && (
                  <Fragment key={field.id}>
                    {" "}
                    {/* Añade el key aquí­ */}
                    {field.type === "autocomplete" ? (
                      <Grid item {...field?.grid} sx={{ padding: "5px" }}>
                        <Autocomplete
                          options={field.options || []} // Asegúrate de que sea un array
                          loading={field.loading}
                          open={field.open}
                          size="small"
                          defaultValue={field?.defaultValue}
                          onOpen={field.onOpen}
                          disabled={field.disabled}
                          onClose={field.onClose}
                          onChange={(event, value) => field.onChange(value)}
                          getOptionLabel={field.getOptionLabel}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <Fragment>
                                    {params.InputProps.endAdornment}
                                  </Fragment>
                                ),
                                form: {
                                  autoComplete: "off", // Desactiva las sugerencias del navegador en el formulario
                                },
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // Truco para evitar que los navegadores activen el autofill
                              }}
                            />
                          )}
                        />
                      </Grid>
                    ) : field.type === "text" ? (
                      <Grid
                        item
                        {...field?.grid}
                        sx={{ padding: "5px" }}
                        key={field.id}
                      >
                        <TextField
                          label={field.label}
                          onChange={field.onChange}
                          variant="outlined"
                          autoComplete="new-password" // Desactiva el autofill general
                          fullWidth
                          size="small"
                          inputProps={{
                            maxLength:
                              field.id === "userPostalCode" ? 10 : undefined,
                          }}
                        />
                      </Grid>
                    ) : field.type === "textarea" ? (
                      <Grid item xs={12} sx={{ padding: "5px" }} key={field.id}>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel sx={{ textAlign: "left" }}>
                            {field.label}
                          </FormLabel>
                          <textarea
                            style={{
                              height: "100px",
                              resize: "none",
                              padding: "6px 13px",
                              fontSize: "15px",
                              borderRadius: "10px",
                              border: "1px solid rgba(128, 128, 128, 0.35)",
                            }}
                            onChange={field.onChange} // Asignar la función onChange
                          />
                        </FormControl>
                      </Grid>
                    ) : null}
                  </Fragment>
                ),
            )}
          </Grid>
          <Grid container p={2}>
            <ButtonGroup
              sx={{
                width: "100%",
              }}
            >
              <Button
                onClick={handleClientsFormInformation}
                variant="outlined"
                color="success"
                size="small"
                disabled={isCompanyLoading}
                sx={{
                  padding: "5px !important",
                  color: "#2e7d32 !important",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                Guardar
              </Button>
              <NavButton
                to={buildTableUrl("usuarios")}
                onClick={() => goTable("usuarios", "Usuarios")}
                variant="outlined"
                color="error"
                size="small"
                sx={{
                  padding: "5px !important",
                  color: "#d32f2f !important",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                Tabla
              </NavButton>
              <Button
                onClick={goPanel}
                variant="outlined"
                size="small"
                sx={{
                  padding: "5px !important",
                  color: "#1976d2 !important",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                Inicio
              </Button>
            </ButtonGroup>
          </Grid>
        </Box>
      </Fade>
    </div>
  );
};

export default Crear;
